export enum PaymentGateway {
	GooglePlay = 1,
	CyberSource,
}
